import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useQuery } from 'react-apollo';

import { formatPriceForDisplay } from '../../../../../util/format-money';
import Button from '../../../../../components/global/Button';
import { EVENT_ITEM_PLAN } from '../../../../../constants/event-items';
import { checkoutPrice as checkoutPriceQuery } from '../../../../../graphql/queries/checkout';
import useAuthenticated from '../../../../../hooks/useAuthenticated';

const propTypes = {
  className: PropTypes.string,
  eventItem: PropTypes.shape({
    id: PropTypes.string,
    video_guestbook_enabled: PropTypes.bool,
  }),
  processing: PropTypes.bool,
  onSelectPlan: PropTypes.func.isRequired,
  skipPayment: PropTypes.bool,
  albumFolderId: PropTypes.string,
  active: PropTypes.bool,
};

const WeddingEventComparisonItem = ({
  eventItem,
  className,
  onSelectPlan,
  processing,
  skipPayment = false,
  albumFolderId,
  active = false,
}) => {
  const authenticated = useAuthenticated();
  const classes = classNames({
    [className]: !!className,
  });

  const isFree =
    eventItem?.price?.value === 0 || eventItem?.plan === EVENT_ITEM_PLAN.FREE;

  const { data: { checkoutPrice } = {}, loading: loadingPrice } = useQuery(
    checkoutPriceQuery,
    {
      variables: {
        event_items: [
          {
            event_item_id: eventItem?.id,
            quantity: 1,
            album_folder_id: albumFolderId,
          },
        ],
      },
      skip: !authenticated || !eventItem || isFree,
      fetchPolicy: 'network-only',
    },
  );

  const priceLabel = (() => {
    if (loadingPrice) {
      return 'Loading...';
    }

    if (!authenticated) {
      // Fallback to whatever pricing this item  has
      return eventItem?.price?.value === 0
        ? 'FREE'
        : `$${formatPriceForDisplay(eventItem?.price?.value)}`;
    }

    return isFree
      ? 'FREE'
      : `$${formatPriceForDisplay(checkoutPrice?.total_price?.value)}`;
  })();

  return (
    <div className={classes}>
      <p className="text-dark text-black mb-0">{eventItem.name}</p>
      <p className="text-sm text-primary mb-1">{priceLabel}</p>

      <Button
        onClick={() => {
          onSelectPlan({ eventItem, skipPayment });
        }}
        disabled={active || processing || loadingPrice}
        btnSize="sm"
        btnStyle={active ? 'active-disabled' : 'primary'}
      >
        {active ? 'Active' : 'Select'}
      </Button>
    </div>
  );
};

WeddingEventComparisonItem.propTypes = propTypes;

export default WeddingEventComparisonItem;
